@if (canSubscribeOrganisation$ | async) {
    <div adaptToolbarContent>
        <a class="btn btn-primary"
           adaptButtonIcon="fal fa-marker"
           [routerLink]="subscribeOrganisationHref$ | async"> Subscribe an organisation </a>
    </div>
}

@let myOrganisationsData = (myOrganisationsData$ | async) ?? [];
@let activeOrganisations = getActiveOrganisations(myOrganisationsData);
@if (activeOrganisations.length > 0) {
    <div class="mb-3 organisation-cards-container">
        @for (orgData of activeOrganisations; track orgData) {
            <adapt-organisation-card [cardData]="orgData"></adapt-organisation-card>
        }
    </div>
}
@let archivedOrganisations = getArchivedOrganisations(myOrganisationsData);
@if (archivedOrganisations.length > 0) {
    <h2 class="mt-4">Archived</h2>
    <div class="mb-3 organisation-cards-container">
        @for (orgData of archivedOrganisations; track orgData) {
            <adapt-organisation-card [cardData]="orgData"></adapt-organisation-card>
        }
    </div>
}

<!-- wait for page to be activated before attempting to show the accordion, otherwise it has 0px height. -->
@if ((isStakeholderManager$ | async) && isActivated) {
    <dx-accordion (onContentReady)="onAccordionReady($event)"
                  [items]="['dummyItem']"
                  [collapsible]="true"
                  [selectedIndex]="myOrganisationsData.length > 1 ? -1 : 0">
        <div *dxTemplate="let item of 'title'">
            <h2 class="mb-0">All Organisations</h2>
        </div>
        <div *dxTemplate="let item of 'item'"
             class="px-1 py-0">
            <adapt-all-organisations-grid></adapt-all-organisations-grid>
        </div>
    </dx-accordion>
}

@if (myOrganisationsData.length <= 1 && !(isStakeholderManager$ | async)) { <adapt-call-to-action [fullPage]="!activeOrganisations.length"
                          learnMoreUrl="https://support.theadaptway.com/coach-kit">
        <adapt-call-to-action-title>Your journey as an adapt coach</adapt-call-to-action-title>
        <p>The adapt way is a proven process to build the leadership, culture, systems and habits customers need to build a successful
            business.</p>
        @if (!isAlto) {
            <p>Begin your journey with a customer by subscribing an organisation.</p>
        }
        @if (canSubscribeOrganisation$ | async) {
            <a adaptCallToActionButton
               adaptButtonIcon="fal fa-marker"
               [routerLink]="subscribeOrganisationHref$ | async"> Subscribe an organisation </a>
        }
    </adapt-call-to-action>
}
